
export function getAccessToken(): string | null {
  try {
    const raw = localStorage.getItem('userInfo');
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { access?: string };
    return parsed?.access ?? null;
  } catch {
    return null;
  }
}
